// src/components/About.js
import { Link } from "react-router-dom";
import appConfig from "../../src/config/appConfig"; // <-- default import (no braces)

const About = () => {
  // appConfig is an OBJECT, so don't call it
  const { companyName, projectName, tagline, year, theme, features, content } = appConfig;

  return (
    <section className="font-sans text-gray-800 bg-gray-100 p-12">
      <header className="text-center pb-8 border-b border-gray-300">
        <h1 className={`${theme.primaryText} text-4xl font-bold`}>
          {companyName}
        </h1>

        <h2 className={`${theme.heading} text-2xl mt-4 italic`}>
          Project: <span className="font-light">{projectName}</span>
        </h2>

        {tagline && <p className="text-base text-gray-600 mt-2">{tagline}</p>}
      </header>

      <main className="pt-8 max-w-3xl mx-auto leading-relaxed">
        {content?.sections?.map((sec) => (
          <section key={sec.id} className="mb-10">
            <h3 className="text-teal-900 text-xl font-semibold">{sec.title}</h3>

            {/* paragraph section */}
            {sec.body && <p>{sec.body}</p>}

            {/* bulleted list section */}
            {Array.isArray(sec.list) && (
              <ul className="list-disc pl-5">
                {sec.list.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </main>

      <footer className="mt-12 pt-8 border-t border-gray-300 text-center">
        <p className="text-gray-600 text-sm">
          &copy; {year} {companyName}. All rights reserved.
        </p>

        {features?.showLoginCta && content?.cta && (
          <div className="mt-4">
            <Link
              className={`${theme.primaryText} text-lg font-mono ${theme.primaryTextHover}`}
              to={content.cta.to}
            >
              {content.cta.label}
            </Link>
          </div>
        )}

        {features?.showLoginCta && content?.backToHome && (
          <div className="mt-4">
            <Link
              className={`${theme.primaryText} text-lg font-mono ${theme.primaryTextHover}`}
              to={content.backToHome.to}
            >
              {content.backToHome.label}
            </Link>
          </div>
        )}
      </footer>
    </section>
  );
};

export default About;
